import { Command, HousePlus, ArrowRightLeft, ChartSpline, Settings2, Sparkles } from "lucide-react"
import type { NavItem } from "@/types/nav"

export const propertyManagerNav: NavItem[] = [
  {
    title: "Company",
    url: "/dashboard/company",
    icon: Command,
    items: [
      {
        title: "Insights",
        url: "/dashboard/property-manager/dashboard/overview",
      },
      // {
      //   title: "Savings",
      //   url: "/dashboard/company/savings",
      // },
      {
        title: "Funding History",
        url: "/dashboard/company/funding-history",
      }
    ],
  },
  {
    title: "Properties",
    url: "/dashboard/properties",
    icon: HousePlus,
    items: [
      {
        title: "Manage Homes",
        url: "/dashboard/properties/manage-homes",
      },
      {
        title: "Manage Services",
        url: "/dashboard/properties/manage-services",
      },
      {
        title: "Deposits",
        url: "/dashboard/properties/deposits",
      },
      {
        title: "Bulk Buy",
        url: "/dashboard/properties/bulk-buy",
      }
    ],
  },
  {
    title: "Transactions",
    url: "/dashboard/transactions",
    icon: ArrowRightLeft,
    items: [
      {
        title: "Pending and Cleared",
        url: "/dashboard/transactions/pending-and-cleared",
      },
      {
        title: "Declined",
        url: "/dashboard/transactions/declined",
      },
      {
        title: "Adjustments",
        url: "/dashboard/transactions/adjustments",
      },
      {
        title: "Fees",
        url: "/dashboard/transactions/fees",
      }
    ],
  },
  {
    title: "Reports",
    url: "/dashboard/reports",
    icon: ChartSpline,
    items: [
      {
        title: "Tenants",
        url: "/dashboard/reports/onboarding-tenants",
      },
      {
        title: "Service Trends",
        url: "/dashboard/reports/service-trends",
      },
      {
        title: "Missing Services",
        url: "/dashboard/reports/missing-services",
      },
      {
        title: "Active Services",
        url: "/dashboard/reports/active-services",
      },
      {
        title: "Statements",
        url: "/dashboard/reports/statements",
      },
      {
        title: "Bill Pay",
        url: "/dashboard/reports/bill-pay",
      },
      {
        title: "Bill Back",
        url: "/dashboard/reports/bill-back",
      },
      {
        title: "Spikes",
        url: "/dashboard/reports/spikes",
      },
      // {
      //   title: "Collections",
      //   url: "/dashboard/reports/collections",
      // },
      {
        title: "Deposits",
        url: "/dashboard/reports/deposits",
      },
      {
        title: "Reconciliation",
        url: "/dashboard/company/accounting-statements",
      },
    ],
  },
  {
    title: "AI Tools",
    url: "/dashboard/ai-tools",
    icon: Sparkles,
    items: [
      {
        title: "Fee Analyzer",
        url: "/dashboard/ai-tools/fee-analyzer",
      }
    ],
  },
  {
    title: "Settings",
    url: "/dashboard/settings",
    icon: Settings2,
    items: [
      {
        title: "Company Information",
        url: "/dashboard/settings/company",
      },
      {
        title: "Members",
        url: "/dashboard/settings/members",
      },
      {
        title: "Integrations",
        url: "/dashboard/settings/integrations",
      },
      {
        title: "Bank Accounts",
        url: "/dashboard/settings/bank",
      },
      {
        title: "Spike Alert Thresholds",
        url: "/dashboard/settings/spike-alert",
      },
      {
        title: "Payment Settings",
        url: "/dashboard/settings/payments",
      },
      {
        title: "Auto Categorization",
        url: "/dashboard/settings/auto-categorization",
      },
      {
        title: "Notifications",
        url: "/dashboard/settings/notifications",
      }
    ],
  }
] 